module.exports = __webpack_public_path__ + "tgm/img/cnt-pro.8fd7fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/cnt-pro.png
// module id = gkT6
// module chunks = 1